import { Component, OnInit, Input, EventEmitter, Optional, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { RefferalService } from '../../services/refferal/refferal.service';
import { movieVM } from '../../models/movieVM';
import { SelectItem } from 'primeng/components/common/api';
import { Message } from 'primeng/components/common/api';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-referral',
  templateUrl: './refferal.component.html'
})
export class RefferalComponent implements OnInit {
  constructor(private _refferalService: RefferalService,
    private route: ActivatedRoute,
    private router: Router
  ) {

  }
  isLoading: boolean = false;
  msgs: Message[] = [];
  model: any = {};
  user: any = {};
  user$ = new Subject<any>();

  ngOnInit() {
    this._refferalService.getAll().subscribe(res => {
      debugger;
      this.isLoading = false;
      setTimeout(() => {
        this.user = res.data;
        this.user$.next(res.data);
      }, 100);
    }, error => {
      debugger;
      this.isLoading = false;
      this.msgs.push({ severity: 'error', summary: 'Error', detail: error })
      this.hideMessage();
    });
  }

  onSubmit(f: any) {
    this.isLoading = true;
    this._refferalService.getAll().subscribe(data => {
      debugger;
      this.isLoading = false;
      this.user = data;
      localStorage.setItem("currentUser", this.user.userToken)
      this.router.navigate(['/dashboard/movies'])
    }, error => {
      debugger;
      this.isLoading = false;
      this.msgs.push({ severity: 'error', summary: 'Error', detail: error })
      this.hideMessage();
    });
  }

  hideMessage() {
    setTimeout(() => {
      this.msgs = [];
    }, 3000);
  }

}





// WEBPACK FOOTER //
// ./src/app/components/refferal/refferal.component.ts